import React, { useEffect, useState } from "react";
import { prefersReducedMotion } from "../processing-script";

const PHRASE_MS = 2400;
const FADE_MS = 520;

const StartProcessing = ({ script }) => {
  const phrases = script?.phrases || [];
  const reduced = prefersReducedMotion();
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    if (reduced || phrases.length < 2) return undefined;
    let fadeTimer;
    const tick = setInterval(() => {
      setVisible(false);
      fadeTimer = setTimeout(() => {
        setIndex((current) => (current + 1) % phrases.length);
        setVisible(true);
      }, FADE_MS);
    }, PHRASE_MS);
    return () => {
      clearInterval(tick);
      clearTimeout(fadeTimer);
    };
  }, [phrases, reduced]);

  if (!script) return null;
  const phrase = phrases[index] || "Working on your file";

  return (
    <section className="start-process" role="status" aria-live="polite" aria-label={script.title}>
      <div className="start-process__orbit" aria-hidden="true">
        <span />
        <span />
        <span />
        <i />
      </div>
      <p className="start-kicker">{script.eyebrow}</p>
      <h2>{script.title}</h2>
      <p className={`start-process__phrase${visible || reduced ? " is-in" : ""}`}>{phrase}</p>
      <div className="start-process__bar is-indeterminate" aria-hidden="true">
        <span />
      </div>
      {script.footnote && <p className="start-muted">{script.footnote}</p>}
    </section>
  );
};

export default StartProcessing;
